import { FieldType, type FormField } from "@aam/shared";
import { Input, Label, Textarea, FieldHelp } from "./ui/Input";

interface InlineFormFieldProps {
  field: FormField;
  value: unknown;
  onChange: (value: unknown) => void;
}

export function InlineFormField({ field, value, onChange }: InlineFormFieldProps) {
  const stringValue = typeof value === "string" ? value : value == null ? "" : String(value);

  return (
    <div className="space-y-1.5">
      <Label htmlFor={field.id}>
        {field.label}
        {field.required ? <span className="text-status-rejected-text ml-1">*</span> : null}
      </Label>
      {field.type === FieldType.TEXTAREA ? (
        <Textarea
          id={field.id}
          value={stringValue}
          onChange={(event) => onChange(event.target.value)}
          placeholder={field.placeholder}
          required={field.required}
          rows={4}
          className="resize-none"
        />
      ) : (
        <Input
          id={field.id}
          type={field.type === FieldType.DATE ? "date" : field.type === FieldType.EMAIL ? "email" : "text"}
          value={stringValue}
          onChange={(event) => onChange(event.target.value)}
          placeholder={field.placeholder}
          required={field.required}
        />
      )}
      {field.helpText && <FieldHelp>{field.helpText}</FieldHelp>}
    </div>
  );
}
